import screenfull from 'screenfull'
let isBrowserSupported = true
let isSecureContext = ''
let MediaRecorder = window.MediaRecorder
let stream = null
let mediaRecorder = null
let recordedChunks = []
let recordingStartTime = ''
let recordingElapsedTime = 0
let totalElapsedTime = 0
let timerInterval = null
let status = ''
let isRecording = false
let isPaused = false
let isRecordingComplete = false
let errorMessage = ''

function checkBrowserSupport() {
    // 检查MediaDevices和getDisplayMedia支持
    if (!navigator.mediaDevices) {
        isBrowserSupported = false;
        // this.$message('您的浏览器不支持媒体设备API，请升级到现代浏览器（Chrome 72+）')
        return;
    }

    if (typeof navigator.mediaDevices.getDisplayMedia !== 'function') {
        isBrowserSupported = false;
        // this.$message('您的浏览器不支持屏幕录制功能，请升级到最新版本的Chrome浏览器')
        return;
    }

    // 检查MediaRecorder支持
    if (typeof MediaRecorder !== 'function') {
        isBrowserSupported = false;
        // this.$message('您的浏览器不支持媒体录制功能，请使用Chrome浏览器')
        return;
    }
    isBrowserSupported = true;
}

// 检查是否在安全上下文环境中
function checkSecureContext() {
    // 安全上下文包括HTTPS、localhost、127.0.0.1等
    isSecureContext = window.isSecureContext;
}

// 停止录制
function stopRecording() {
    if (mediaRecorder && mediaRecorder.state !== 'inactive') {
        mediaRecorder.stop();

        // 停止所有轨道
        if (stream) {
            stream.getTracks().forEach(track => track.stop());
        }

        // 清理计时器
        clearInterval(timerInterval);

        // 更新状态
        status = '录制已完成';
        isRecording = false;
        isPaused = false;
        isRecordingComplete = true;

        setTimeout(() => {
            downloadVideo()
        }, 500);
    }
}

// 下载视频
function downloadVideo() {
    if (recordedChunks.length > 0) {
        const mimeType = 'video/mp4; codecs=avc1.42E01E,mp4a.40.2'
        const extension = 'mp4';

        const blob = new Blob(recordedChunks, { type: mimeType });
        const url = URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        const date = new Date();
        const fileName = `17886-${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}-${date.getHours().toString().padStart(2, '0')}${date.getMinutes().toString().padStart(2, '0')}.${extension}`;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();

        // 清理
        setTimeout(() => {
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
            recordedChunks = [];
            totalElapsedTime = 0;
            status = '准备就绪';
            isRecordingComplete = false;
        }, 100);
    }
}

function updateTimer() {
  const currentTime = Date.now();
  totalElapsedTime = recordingElapsedTime + (currentTime - recordingStartTime);
}

async function startRecording() {
    let vdom = document.querySelector('.editMenu')
    try {
        vdom.style.display = 'none'
        errorMessage = ''

        // // 再次检查浏览器支持
        // if (!isBrowserSupported) {
        //     throw new Error('您的浏览器不支持录屏功能');
        // }

        // // 再次检查安全上下文
        // if (!isSecureContext) {
        //     throw new Error('屏幕录制需要在安全上下文（HTTPS或localhost）中运行');
        // }

        const fps = parseInt(60);

        // 获取分辨率约束
        const videoConstraints = {
            width: { ideal: 3840, max: 3840 },
            height: { ideal: 2160, max: 2160 },
            frameRate: { ideal: fps, max: fps },
            cursor: "always",
            displaySurface: 'window',
        };

        // 配置捕获选项
        const displayMediaOptions = {
            video: videoConstraints,
            audio: false,
            preferCurrentTab: false,
            selfBrowserSurface: "include",
            surfaceSwitching: "exclude",
            systemAudio: "exclude"
        };

        // 检查getDisplayMedia是否存在
        if (typeof navigator.mediaDevices.getDisplayMedia !== 'function') {
            throw new Error('您的浏览器不支持屏幕录制API，请升级浏览器');
        }

        // 请求屏幕捕获
        stream = await navigator.mediaDevices.getDisplayMedia(displayMediaOptions);

        // 检查视频轨道
        const videoTracks = stream.getVideoTracks();
        if (videoTracks.length === 0) {
            throw new Error("无法获取视频轨道，请检查权限设置");
        }

        const videoTrack = videoTracks[0];

        // 确定格式和MIME类型
        const mimeType = 'video/mp4; codecs=avc1.42E01E,mp4a.40.2'

        // 配置MediaRecorder
        const videoBitsPerSecond = 50000000
        const audioBitsPerSecond = 0

        const options = {
            mimeType,
            videoBitsPerSecond,
            audioBitsPerSecond,
            bitsPerSecond: videoBitsPerSecond + audioBitsPerSecond
        };

        mediaRecorder = new MediaRecorder(stream, options);

        // 处理录制数据
        mediaRecorder.ondataavailable = (event) => {
            if (event.data.size > 0) {
                recordedChunks.push(event.data);
            }
        };

        // 监听录制错误
        mediaRecorder.onerror = (event) => {
            console.error('录制错误:', event.error);
            this.stopRecording();
        };

        setTimeout(() => {
            screenfull.toggle()
            setTimeout(() => {
                // 开始录制
                mediaRecorder.start();
                recordingStartTime = Date.now();
                recordingElapsedTime = 0;
                totalElapsedTime = 0;
                timerInterval = setInterval(() => updateTimer(), 1000);

                // 更新状态
                status = `正在录制当前窗口...`;
                isRecording = true;
                isPaused = false;
                isRecordingComplete = false;

                // 监听流结束事件
                videoTrack.onended = () => {
                    vdom.style.display = 'flex'
                    stopRecording();
                };
            }, 1500);
        }, 500);
        setTimeout(() => {
            vdom.style.display = 'flex'
            stopRecording()
        }, 15000);
    } catch (error) {
        console.error('录制启动失败:', error)
        status = `启动失败`
        errorMessage = error.message
        isRecording = false
        isPaused = false
        vdom.style.display = 'flex'
    }
}

export { startRecording }